<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Delivery Order" active>

                                <b-row v-if="hasFailedDataDeliveryOrder">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedDeliveryOrder.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryOrdersFailed" :fields="fieldsDeliveryOrder" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryOrder" :sort-desc.sync="sortDescDeliveryOrder" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(doDate)="row">
													{{ row.item.doDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedDeliveryOrder.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryOrders" :fields="fieldsDeliveryOrder" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryOrder" :sort-desc.sync="sortDescDeliveryOrder" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(doDate)="row">
													{{ row.item.doDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Delivery Order Detail" active>

                                <b-row v-if="hasFailedDataDeliveryOrderDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedDeliveryOrderDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryOrderDetailsFailed" :fields="fieldsDeliveryOrderDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryOrderDetail" :sort-desc.sync="sortDescDeliveryOrderDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyPerUnit)="row">
													{{ Number(row.item.qtyPerUnit).toLocaleString() }}
												</template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedDeliveryOrderDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryOrderDetails" :fields="fieldsDeliveryOrderDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryOrderDetail" :sort-desc.sync="sortDescDeliveryOrderDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyPerUnit)="row">
													{{ Number(row.item.qtyPerUnit).toLocaleString() }}
												</template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import DeliveryOrder from '@/models/DeliveryOrder/DeliveryOrder';
import DeliveryOrderList from '@/models/DeliveryOrder/DeliveryOrderList';
import DeliveryOrderFilter from '@/filters/DeliveryOrder/DeliveryOrderFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsDeliveryOrder: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "DO Date", key: 'doDate', sortable: false},
				{"class" : "th-status", "label" : "Delivery Order Status", key: 'deliveryOrderStatusName', sortable: false},
				{"class" : "th-status", "label" : "Customer", key: 'customerCode', sortable: false},
				{"class" : "th-status", "label" : "Remarks", key: 'remarks', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsDeliveryOrderDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "PO Number", key: 'poNumber', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "QtyPerUnit", key: 'qtyPerUnit', sortable: false},
				{"class" : "th-status", "label" : "Delivery Date", key: 'deliveryDate', sortable: false},
				{"class" : "th-status", "label" : "Purchase Order Detail", key: 'poDetailQtyPo', sortable: false},
				{"class" : "th-status", "label" : "Delivery Status", key: 'deliveryStatusName', sortable: false},
				{"class" : "th-status", "label" : "DO Progress Status", key: 'doProgressStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			deliveryOrders : [],
			deliveryOrdersFailed: [],
			deliveryOrderId : '',
			sortByDeliveryOrder: '',
			sortDescDeliveryOrder: '',
			hasFailedDataDeliveryOrder: false,
			totalFailedDeliveryOrder: 0,
			totalSucceedDeliveryOrder: 0,
			deliveryOrderDetails : [],
			deliveryOrderDetailsFailed: [],
			deliveryOrderDetailId : '',
			sortByDeliveryOrderDetail: '',
			sortDescDeliveryOrderDetail: '',
			hasFailedDataDeliveryOrderDetail: false,
			totalFailedDeliveryOrderDetail: 0,
			totalSucceedDeliveryOrderDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('deliveryorder/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('deliveryorder/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getDeliveryOrderForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getDeliveryOrderForUpload : async function() {
			let _this = this;
			this.$http.get('deliveryorder/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.deliveryOrders = [];
_this.deliveryOrderDetails = [];


					if (response != null) {
						let result = response.data;
						_this.deliveryOrders = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedDeliveryOrder = _this.deliveryOrders.length;

						_this.deliveryOrdersFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataDeliveryOrder = true;
						_this.totalFailedDeliveryOrder = 0;
						if(_this.deliveryOrdersFailed == undefined || _this.deliveryOrdersFailed.length === 0) _this.hasFailedDataDeliveryOrder = false;
						if(_this.hasFailedDataDeliveryOrder) _this.totalFailedDeliveryOrder = _this.deliveryOrdersFailed.length;
						_this.deliveryOrderDetails = [];
						_this.deliveryOrderDetailsFailed = [];
						_this.hasFailedDataDeliveryOrderDetail = true;
						_this.totalSucceedDeliveryOrderDetail = 0;
						result.forEach(function(element) {
							_this.deliveryOrderDetails.push(...element.deliveryOrderDetails.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedDeliveryOrderDetail = _this.deliveryOrderDetails.length;

							_this.deliveryOrderDetailsFailed.push(...element.deliveryOrderDetails.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.deliveryOrderDetailsFailed == undefined || _this.deliveryOrderDetailsFailed.length === 0) _this.hasFailedDataDeliveryOrderDetail = false;
							if(_this.hasFailedDataDeliveryOrderDetail) _this.totalFailedDeliveryOrderDetail = _this.deliveryOrderDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'deliveryorder/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'DeliveryOrder.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterDeliveryOrder = new DeliveryOrderFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
